import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("opscmd_user") || "null"); }
    catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("opscmd_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => { setUser(r.data); localStorage.setItem("opscmd_user", JSON.stringify(r.data)); })
      .catch(() => { localStorage.removeItem("opscmd_token"); setUser(null); })
      .finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("opscmd_token", r.data.token);
    localStorage.setItem("opscmd_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const register = useCallback(async (payload) => {
    const r = await api.post("/auth/register", payload);
    localStorage.setItem("opscmd_token", r.data.token);
    localStorage.setItem("opscmd_user", JSON.stringify(r.data.user));
    setUser(r.data.user);
    return r.data.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("opscmd_token");
    localStorage.removeItem("opscmd_user");
    setUser(null);
  }, []);

  const refreshUser = useCallback(async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
    localStorage.setItem("opscmd_user", JSON.stringify(r.data));
    return r.data;
  }, []);

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
